
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceintaloja() {



const cardData = {
  keyword: 'Cab Service in Taloja MIDC Mumbai',
  heading: 'eTravo: Reliable and Efficient Cab Services in Taloja MIDC, Mumbai',
  headingDescription: 'eTravo offers dependable and professional cab services in Taloja MIDC, catering to the transportation needs of businesses and employees in this bustling industrial hub. Whether you require daily staff commutes, executive travel, or airport transfers, our services are designed to be punctual, comfortable, and customizable. With GPS-enabled vehicles, courteous chauffeurs, and flexible booking options, eTravo supports companies of all sizes in managing seamless transport within Taloja MIDC and to other parts of Mumbai and Navi Mumbai.',

  top: 'Top Industrial Landmarks in Taloja MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'Lodha Industrial and Logistics Park',
      description: 'A prominent industrial park housing various manufacturing and logistics companies. eTravo provides scheduled cab services for employees and executives commuting to and from this location, ensuring timely arrivals and departures.'
    },
    {
      title: 'ESR Taloja MIDC Industrial Park',
      description: 'Home to several enterprises, ESR Taloja MIDC Industrial Park requires reliable transportation solutions. Our cab services cater to the daily commute needs of professionals working here, offering comfort and punctuality.'
    },
    {
      title: 'Mahima Complex',
      description: 'A commercial complex accommodating various businesses. eTravo offers dedicated cab services for staff and clients visiting Mahima Complex, facilitating smooth and efficient travel experiences.'
    },
    {
      title: 'Siddhivinayak Garima',
      description: 'An industrial area hosting numerous manufacturing and service companies. Our cab services support the transportation requirements of employees and management, providing safe and timely commutes.'
    },
    {
      title: 'Greenvalley Metropolis',
      description: 'A commercial complex with diverse businesses. eTravo ensures seamless transportation for professionals working here, with flexible scheduling and route customization.'
    },
    {
      title: 'Lavender CHS',
      description: 'A significant office building in the area. Our cab services assist in the daily transportation of employees and visitors, emphasizing reliability and comfort.'
    },
    {
      title: 'Amar Harmony',
      description: 'A residential and commercial complex attracting numerous customers. eTravo offers cab services for clients and staff, ensuring convenient and hassle-free travel.'
    },
    {
      title: 'Arihant Amisha',
      description: 'A commercial complex serving a wide clientele. Our cab services facilitate easy access for customers and employees, enhancing overall service experience.'
    },
    {
      title: 'Taloja CETP',
      description: 'A common effluent treatment plant located in Taloja MIDC. eTravo collaborates to provide efficient transportation solutions for their operational needs.'
    },
    {
      title: 'Taloja Industries Association',
      description: 'A key industrial association in the area. Our cab services support the commuting needs of association members and clients, ensuring timely and comfortable travel.'
    }
  ],

  services: [
    {
      name: 'Taloja MIDC Corporate Cab Rentals',
      description: 'Customized cab rental solutions for businesses operating in Taloja MIDC. We offer fixed-term and flexible cab rental plans for employee travel, corporate events, and executive mobility.'
    },
    {
      name: 'Employee Transport Cab Taloja MIDC',
      description: 'Daily and on-call cab services designed for employees commuting to and from Taloja MIDC. Choose from a range of vehicles, all equipped with GPS tracking and professional drivers.'
    },
    {
      name: 'Business Cab Service Taloja MIDC',
      description: 'Reliable cab services for business owners, field agents, and visiting clients. Our fleet includes sedans, SUVs, and executive-class vehicles to meet diverse corporate needs.'
    },
    {
      name: 'Corporate Staff Cabs Taloja MIDC',
      description: 'Structured transportation solutions for staff working in the industrial area, including shift-based schedules, multi-stop routes, and real-time fleet tracking.'
    },
    {
      name: 'Reliable Corporate Cabs Taloja MIDC',
      description: 'Trusted by companies in Taloja MIDC for timely cab arrivals, clean vehicles, and professional drivers, ensuring seamless daily commutes and business travel.'
    },
    {
      name: 'AC Cabs for Businesses Taloja MIDC',
      description: 'All our cabs are air-conditioned, sanitized, and equipped with comfortable seating, ensuring a pleasant travel experience for your employees and clients.'
    },
    {
      name: 'Taloja MIDC Office Commute Cabs',
      description: 'Round-the-clock pickup and drop services for employees across various shifts and departments. Our cabs are scheduled according to your operational calendar to maximize productivity.'
    },
    {
      name: 'Corporate Event Cabs Taloja MIDC',
      description: 'Cab rental services tailored for business travel within and outside Taloja MIDC, including client meetings, site visits, and inter-office commutes.'
    },
    {
      name: 'Affordable Business Cab Rentals Taloja MIDC',
      description: 'Cost-effective cab services with flexible billing options,  capabilities, and monthly contracts, catering to businesses of all sizes in Taloja MIDC.'
    },
    {
      name: 'Executive Cab Service Taloja MIDC',
      description: 'Premium cab services for company executives and VIP clients, featuring top-end vehicles, professionally dressed chauffeurs, and absolute punctuality.'
    },
    {
      name: 'Staff Pickup and Drop Taloja MIDC',
      description: 'Dedicated cab services for staff transportation, including daily commutes, inter-office travel, and special events, with a focus on reliability and comfort.'
    },
    {
      name: 'Corporate Client Transport Taloja MIDC',
      description: 'Professional cab services for business meetings, client visits, and corporate events, ensuring timely arrivals and a comfortable travel experience.'
    },
    {
      name: 'Monthly Cab Service Taloja MIDC',
      description: 'Comprehensive employee transportation solutions, including fixed-route cabs, shift-based arrangements, and real-time tracking for enhanced safety and efficiency.'
    },
    {
      name: 'Taloja MIDC Industrial Area Cab Hire',
      description: 'End-to-end cab coordination for daily staff commutes, team transfers, and multi-stop business routing across industrial and commercial zones in Taloja MIDC.'
    },
    {
      name: 'Business Meeting Cabs Taloja MIDC',
      description: 'On-demand taxi services for quick and convenient travel within Taloja MIDC and to nearby locations, ensuring flexibility and responsiveness.'
    }
  ],

  tableData: [
    ['Taloja MIDC Corporate Cab Rentals', 'Employee Transport Cab Taloja MIDC'],
    ['Business Cab Service Taloja MIDC', 'Corporate Staff Cabs Taloja MIDC'],
    ['Reliable Corporate Cabs Taloja MIDC', 'AC Cabs for Businesses Taloja MIDC'],
    ['Taloja MIDC Office Commute Cabs', 'Corporate Event Cabs Taloja MIDC'],
    ['Affordable Business Cab Rentals Taloja MIDC', 'Executive Cab Service Taloja MIDC'],
    ['Staff Pickup and Drop Taloja MIDC', 'Corporate Client Transport Taloja MIDC'],
    ['Monthly Cab Service Taloja MIDC', 'Taloja MIDC Industrial Area Cab Hire'],
    ['Business Meeting Cabs Taloja MIDC', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Cab Services for Taloja MIDC Corporates",
        "WhyChoosedescription": "eTravo offers dependable cab services tailored for businesses operating in Taloja MIDC, ensuring timely and efficient transportation solutions for employees and executives."
    },
    {
        "WhyChooseheading": "Diverse Fleet to Meet Corporate Needs",
        "WhyChoosedescription": "Our fleet includes a range of vehicles from sedans to SUVs, catering to various corporate requirements, whether it's daily commutes, client meetings, or inter-office travel."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Taloja MIDC",
        "WhyChoosedescription": "Our drivers possess in-depth knowledge of Taloja MIDC and surrounding areas, ensuring efficient navigation and adherence to schedules."
    },
    {
        "WhyChooseheading": "Flexible Booking Options",
        "WhyChoosedescription": "We offer flexible booking solutions, including one-time rides, daily commutes, and monthly contracts, providing convenience and adaptability to corporate clients."
    },
    {
        "WhyChooseheading": "Real-Time Tracking and Monitoring",
        "WhyChoosedescription": "Our cabs are equipped with GPS tracking systems, allowing real-time monitoring of rides, enhancing safety and accountability."
    },
    {
        "WhyChooseheading": "Transparent Billing with Detailed Invoices",
        "WhyChoosedescription": "We provide clear and detailed billing statements, facilitating easy expense tracking and reimbursement processes for corporate finance teams."
    },
    {
        "WhyChooseheading": "Safety and Hygiene Protocols",
        "WhyChoosedescription": "In adherence to health and safety standards, our vehicles undergo regular sanitization, and drivers follow strict hygiene protocols, ensuring a safe travel environment."
    },
    {
        "WhyChooseheading": "Dedicated Customer Support",
        "WhyChoosedescription": "Our dedicated customer support team is available to assist with bookings, address queries, and provide personalized support, ensuring a seamless transportation experience."
    }
]
}


const faqData = [
    [
        {
            question: 'Which areas do your cab services cover in and around Taloja MIDC?',
            answer: 'Our services encompass Taloja MIDC and neighboring regions, including Panvel, Kharghar, and other key commercial zones.'
        },
        {
            question: 'Can we schedule recurring rides for our employees?',
            answer: 'Yes, we offer options to schedule recurring rides, ensuring consistent and timely transportation for your employees.'
        },
        {
            question: 'Do you provide monthly billing options for corporate clients?',
            answer: 'Absolutely. We offer monthly billing cycles with detailed invoices to streamline your company’s expense management.'
        },
        {
            question: 'Are your drivers trained in corporate etiquette?',
            answer: 'Yes, our drivers undergo training to maintain professionalism and adhere to corporate etiquette, ensuring a pleasant experience for your staff.'
        },
        {
            question: 'How do you ensure the safety of passengers during rides?',
            answer: 'We implement real-time GPS tracking, regular vehicle maintenance, and strict adherence to safety protocols to ensure passenger safety.'
        },
        {
            question: 'Is there a dedicated support line for corporate clients?',
            answer: 'Yes, corporate clients have access to a dedicated support line and account manager for prompt assistance and service customization.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Rajesh Sharma',
        designation: 'Operations Manager, TechNova Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s cab services have significantly improved our employee punctuality and satisfaction. Their professionalism and reliability are commendable.”'
    },
    {
        name: 'Ms. Priya Desai',
        designation: 'HR Executive, GreenField Industries',
        rating: [1, 1, 1, 1, 1],
        text: '“The flexibility and support provided by eTravo have made our corporate transportation seamless. Their attention to detail is truly appreciated.”'
    }
];




















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Taloja MIDC Mumbai",
  "image": "https://www.etravo.in/images/keyword/cab-service-taloja-midc-mumbai.jpg",
  "description": "Book reliable cab services in Taloja MIDC Mumbai for corporate staff transport, office commutes, business meetings, and industrial area travel. Affordable AC corporate cabs with professional drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7548"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-taloja-midc-mumbai"
  }
};







    return (
        <div>

<Helmet>
  <title>Cab Service in Taloja MIDC Mumbai | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services in Taloja MIDC Mumbai for corporate employees, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceintaloja;